import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20entertainment%20scene%20with%20dark%20atmosphere%2C%20red%20carpet%20leading%20into%20bright%20spotlights%2C%20paparazzi%20camera%20flashes%2C%20mysterious%20silhouettes%2C%20hollywood%20glamour%20mixed%20with%20dark%20secrets%2C%20film%20noir%20aesthetic%2C%20warm%20red%20and%20gold%20accents%20on%20black%20background&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="黑料不打烊 - 娱乐圈爆料平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
          </span>
          <span className="text-xs font-medium text-primary-300 whitespace-nowrap">实时追踪中</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-4">
          黑料不打烊
        </h1>
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-4 leading-relaxed">
          全天24小时不间断追踪娱乐圈最新爆料、明星黑料与劲爆内幕
        </p>
        <p className="text-sm md:text-base text-white/50 max-w-xl mx-auto mb-8">
          独家扒皮、深度揭秘，让你第一时间掌握圈内真相，错过一秒都是损失
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/star-scandal"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-bold rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-flashlight-line mr-2"></i>
            立即吃瓜
          </Link>
          <a
            href="#latest"
            className="w-full sm:w-auto px-8 py-3 border border-white/40 text-white font-medium rounded-lg hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-arrow-down-line mr-2"></i>
            查看最新爆料
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-white/40 text-xs">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i> 日均百万吃瓜群众
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-article-line"></i> 独家爆料1000+
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i> 24小时不间断
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}